import {useEffect, useState} from 'react'

const  useLiveLocation = () => {
    const[liveLoc, setLiveLoc] = useState({lat: "", long: "", loadComplete: false});
    
    const onSuccess = (loc) => {
        setLiveLoc({
            lat: loc.coords.latitude, 
            long: loc.coords.longitude,
            loadComplete: true,
        });   
    };

    const onError = error => {
        setLiveLoc({
            loadComplete: true,
            error,
        })
    }


    useEffect(() => {

        //check if browser supports geolocation
        if (!("goelocation" in navigator) ){
            onError({errorMsg: "Please wait a few seconds and try again. If no response, your browser may not support geolocation."});
        }
        
        //request location
        navigator.geolocation.getCurrentPosition(onSuccess, onError);

    },[])
    return liveLoc
}

export default useLiveLocation